/**
 * Utility functions for lead category color coding
 */

/**
 * Get the color class name for a lead based on its category
 * @param lead_category - The lead category number
 * @returns CSS class name for the color
 */
export const getLeadCategoryColor = (lead_category?: number): string => {
  if (!lead_category || lead_category <= 1) {
    return ''; // Default color (no special styling)
  }
  
  if (lead_category === 2) {
    return 'lead-category-2'; // Light blue
  }
  
  if (lead_category === 3) {
    return 'lead-category-3'; // Yellow
  }
  
  if (lead_category >= 4) {
    return 'lead-category-4'; // Soft red
  }
  
  return ''; // Default
};

/**
 * Get the color style object for a lead based on its category
 * @param lead_category - The lead category number
 * @returns Style object with color property
 */
export const getLeadCategoryStyle = (lead_category?: number): React.CSSProperties => {
  if (!lead_category || lead_category <= 1) {
    return {}; // Default color (no special styling)
  }
  
  if (lead_category === 2) {
    return { color: '#81d4fa' }; // Light blue
  }
  
  if (lead_category === 3) {
    return { color: '#f4d03f' }; // Muted yellow
  }
  
  if (lead_category >= 4) {
    return { color: '#ffcdd2' }; // Soft red
  }
  
  return {}; // Default
};

/**
 * Get the category description for a lead
 * @param lead_category - The lead category number
 * @returns Description of the category
 */
export const getLeadCategoryDescription = (lead_category?: number): string => {
  if (!lead_category || lead_category <= 1) {
    return 'Lead novo ou primeira atribuição';
  }
  
  if (lead_category === 2) {
    return 'Segunda atribuição';
  }
  
  if (lead_category === 3) {
    return 'Terceira atribuição';
  }
  
  if (lead_category >= 4) {
    return 'Múltiplas re-atribuições';
  }
  
  return 'Lead novo';
};
